export default "__VITE_PUBLIC_ASSET__7f04d27c__"